import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import App from "./App";
import ErrorMessage from "./component/common/Message";
import Configuration from "./environment";
import theme from "./theme";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { AuthProvider, initUserManager } from "oidc-react";
import axios from "axios";
import reducer from "./reducers";
import { configureStore } from "@reduxjs/toolkit";
import { Log } from "oidc-react"


window.activeOidcDebug = () => {
  Log.setLogger(console)
}


let store = configureStore(
  { reducer },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

window.store = store;

const oidcConfig = {
  onSignIn: () => {
    // Redirect?
    let idToken = JSON.parse(
      sessionStorage.getItem(
        "oidc.user:" +
        Configuration.oidc_authority +
        ":" +
        Configuration.oidc_client_id
      )
    )["id_token"];
    axios
      .post(Configuration.backend_api_url + "/validate-token", null, {
        headers: { idToken },
      })
      .then((resp) => {
        localStorage.setItem("token", "Bearer " + resp.data.authorization);
        localStorage.setItem("user", resp.data.username);
        if (resp.data.userPic !== undefined) {
          localStorage.setItem("userPic", atob(resp.data.userPic));
        }
        window.history.push("/home");
        window.location.reload()
      });
  },
  authority: Configuration.oidc_authority,
  clientId: Configuration.oidc_client_id,
  redirectUri: Configuration.oidc_redirect_uri,
  metadata: {
    issuer: "https://accounts.google.com",
    userinfo_endpoint: "https://openidconnect.googleapis.com/v1/userinfo",
    authorization_endpoint: "https://accounts.google.com/o/oauth2/v2/auth",
    token_endpoint: Configuration.backend_api_url + "/token",
  },
  responseType: "code",
  scope: "openid email",
};
let userManager;
if (Configuration.oidc_authority) {
  userManager = initUserManager(oidcConfig);
  window.userManager = userManager;
}
// put metadata
ReactDOM.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
    <CssBaseline />
    <Provider store={store}>
      {Configuration.oidc_authority ? (
        <AuthProvider {...oidcConfig} autoSignIn={false}>
          <Router>
            <Switch>
              <Route
                path="/login/callback"
                render={(routeProps) => (
                  userManager.signinCallback()
                    .then(user => {
                      // `user.state` will reflect the state that was passed in via signinArgs.
                      let idToken = JSON.parse(
                        sessionStorage.getItem(
                          "oidc.user:" +
                          Configuration.oidc_authority +
                          ":" +
                          Configuration.oidc_client_id
                        )
                      )["id_token"];
                      axios
                        .post(
                          Configuration.backend_api_url + "/validate-token",
                          null,
                          {
                            headers: { idToken },
                          }
                        )
                        .then((resp) => {
                          localStorage.setItem(
                            "token",
                            "Bearer " + resp.data.authorization
                          );
                          localStorage.setItem("user", resp.data.username);
                          if (resp.data.userPic !== undefined) {
                            localStorage.setItem(
                              "userPic",
                              atob(resp.data.userPic)
                            );
                          }
                          routeProps.history.push("/home");
                          window.location.reload()
                        });
                    }))}
              />
              <>
                <ErrorMessage />
                <App />
              </>
            </Switch>
          </Router>
        </AuthProvider>
      ) : (
        <Router>
          <Switch>
            <>
              <ErrorMessage />
              <App />
            </>
          </Switch>
        </Router>
      )}
    </Provider>
    </ThemeProvider>
  </StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
